/**
 * SKIO Swatch and Dropdown Sync Script
 * Syncs SKIO plan picker dropdown with product swatches
 * Extracted from inline script for better performance
 */
(function() {
  'use strict';
  
  // Only run on product pages
  if (document.querySelector('skio-plan-picker') === null) {
    return;
  }
  
  function initSkioSwatchSync() {
    const currentPathname = window.location.pathname;
    const currentHref = window.location.href;
    
    let isPathPresent = false;
    if (currentPathname.includes('/products/pcos-protein') || 
        currentPathname.includes('/products/the-pcos-protein-anti-androgenic-low-carb-high-protein-designed-for-cysters-copy?') ||
        currentHref.includes('product=pcos-protein&') || 
        currentHref.includes('product=the-pcos-protein-anti-androgenic-low-carb-high-protein-designed-for-cysters-copy&')) {
      isPathPresent = true;
    }

    let skioSelectOptions = null;
    const shadowHost = document.querySelector('skio-plan-picker');
    
    // Swatches: The PCOS Protein
    let gfSwatchSpans = document.querySelectorAll('.gf_swatch');

    let hasChocolate = Array.from(gfSwatchSpans).some(singleInput => singleInput.getAttribute('data-value') == 'Chocolate');
    let hasCoconut = Array.from(gfSwatchSpans).some(singleInput => singleInput.getAttribute('data-value') == 'Coconut');
    let hasSalted = Array.from(gfSwatchSpans).some(singleInput => singleInput.getAttribute('data-value') == 'Salted Caramel Latte');
    let hasDoubleChoc = Array.from(gfSwatchSpans).some(singleInput => singleInput.getAttribute('data-value') == 'Double Choc');

    let flavorsSwatches = null;
    
    if(isPathPresent) {
      let withoutfalvorsS = null;
      
      if(hasChocolate && hasSalted) {
        withoutfalvorsS = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') != 'Chocolate' && singleInput.getAttribute('data-value') != 'Salted Caramel Latte');
        flavorsSwatches = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') == 'Chocolate' || singleInput.getAttribute('data-value') == 'Salted Caramel Latte');

      } else if(hasDoubleChoc && hasSalted) {
        withoutfalvorsS = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') != 'Double Choc' && singleInput.getAttribute('data-value') != 'Salted Caramel Latte');
        flavorsSwatches = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') == 'Double Choc' || singleInput.getAttribute('data-value') == 'Salted Caramel Latte');
        
      } else if(hasChocolate && hasCoconut) {
        withoutfalvorsS = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') != 'Chocolate' && singleInput.getAttribute('data-value') != 'Coconut');
        
      } else if(hasChocolate && !hasCoconut) {
        withoutfalvorsS = Array.from(gfSwatchSpans)?.filter(singleInput => singleInput.getAttribute('data-value') != 'Chocolate');
      }

      gfSwatchSpans = withoutfalvorsS;
    }
    
    const gfSwatchSpans2 = document.querySelectorAll('swatches__holder > span');

    // Swatches: Nourished Androgen Blocker, Nourished Cycle Regulate
    const productPageElement = document.getElementById('product--page');
    const productSwatchesSpans = productPageElement?.querySelectorAll('.product__swatches span[data-swatch-option]');

    
    if(shadowHost && shadowHost?.shadowRoot) {
      const skioFrequencySelect = shadowHost.shadowRoot.querySelector('.skio-frequency');
      if(skioFrequencySelect) {
        skioSelectOptions = skioFrequencySelect;
        skioFrequencySelect.addEventListener('change', function(event) {
          const selectedIndex = skioFrequencySelect.selectedIndex;
          handleSelectionToRenderSwatch(skioFrequencySelect, selectedIndex);
        });
      }
    }

    function handleSelectionToRenderSwatch(selectElement, index) {       
      const selectElementOptionCount = selectElement?.options?.length;        
      if(gfSwatchSpans.length > 0) {
        // Remove selection from all swatches
        gfSwatchSpans.forEach(span => span.classList.remove('gf_selected'));
        // Add selection to the corresponding swatch
        const selectedSwatch = gfSwatchSpans[index];
        if (selectedSwatch) {
          selectedSwatch.classList.add('gf_selected');
          selectedSwatch.click();
        }
      }

      if(productSwatchesSpans?.length > 0) {
        productSwatchesSpans.forEach(span => span.classList.remove('swatch--active'));
        const selected_Swatch = productSwatchesSpans[index];
        if(selected_Swatch) {
          selected_Swatch.click();
          setTimeout(() => {
            selected_Swatch.classList.add("swatch--active");
          }, 0);
        }
      }

      if(gfSwatchSpans2.length > 0) {
        gfSwatchSpans2.forEach(span => span.classList.remove('swatch--active'));
        const selectedSwatch2 = gfSwatchSpans2[index];
        if (selectedSwatch2) {
          selectedSwatch2.classList.add('swatch--active');
          selectedSwatch2.click();
        }
      }

      // Update the selected option in the dropdown
      if (skioSelectOptions?.options[index] || selectElement?.options[index] ) {
        const selectedOption = skioSelectOptions.options[index] || selectElement.options[index];
        selectedOption.setAttribute('data-selected', 'true');
      }        
    }

    function handleFlavorLabel(selectedFlavorText) {
      const flavorLabel = document.querySelector('.gf_swatches-option1 label');        
      const existingFlavorText = flavorLabel?.querySelector('.selected-flavor-text');
      
      if (!flavorLabel) return;
      
      if (existingFlavorText) {
          existingFlavorText.remove();
      }

      if (!flavorLabel.textContent.includes(':')) {
          flavorLabel.textContent += ": ";
      }
      
      const flavorTextElement = document.createElement('span');
      flavorTextElement.className = 'selected-flavor-text';
      flavorTextElement.textContent = selectedFlavorText;
      
      flavorLabel.appendChild(flavorTextElement);
    }
    
    if(flavorsSwatches && flavorsSwatches.length > 0) {
      setTimeout(() => {
        let selectedFlavorSwatch = Array.from(flavorsSwatches).find(singleItem => singleItem.classList.contains('gf_selected'));
        if (selectedFlavorSwatch) {
          selectedFlavorSwatch.click();
        }
      }, 3500);
      
      flavorsSwatches.forEach((span, index) => {
        span.addEventListener('click', () => {
          const extractedText = span.querySelector('.value-1')?.textContent;
          if (extractedText) {
            handleFlavorLabel(extractedText);
          }
        });
      });
    }

    function handleQuantityLabel(selectedQuantityText) {
      const quantityLabel = document.querySelector('.gf_swatches-option2 label');        
      const existingFlavorText = quantityLabel?.querySelector('.selected-flavor-text');
      
      if (!quantityLabel) return;
      
      if (existingFlavorText) {
          existingFlavorText.remove();
      }

      if (!quantityLabel.textContent.includes(':')) {
          quantityLabel.textContent += ": ";
      }
      
      const flavorTextElement = document.createElement('span');
      flavorTextElement.className = 'selected-flavor-text';
      flavorTextElement.textContent = selectedQuantityText;
      
      quantityLabel.appendChild(flavorTextElement);
    }

    if(gfSwatchSpans.length > 0) {
      setTimeout(() => {
        let selectedTubeSwatch = Array.from(gfSwatchSpans)
          .filter(singleInput => singleInput.getAttribute('data-value') != 'Chocolate')
          .find(singleItem => singleItem.classList.contains('gf_selected'))     
        
        if (selectedTubeSwatch) {
          selectedTubeSwatch.click();
        }
      }, 3500);
      
      gfSwatchSpans.forEach((span, index) => {
        span.addEventListener('click', () => {
          handleSwatchToRenderSelectionOption(index);

          const extractedText = span.querySelector('.value-1')?.textContent;
          if (extractedText) {
            handleQuantityLabel(extractedText);
          }
        });
      });
    }
    
    if(productSwatchesSpans?.length > 0) {
      productSwatchesSpans.forEach((span, index) => {
        span.addEventListener('click', () => {
          handleSwatchToRenderSelectionOption(index);
        });
      });
    }

    // Handle Swatch to update dropdown options UI
    function handleSwatchToRenderSelectionOption(index) {
      if(skioSelectOptions && skioSelectOptions?.options[index]) {
        skioSelectOptions.selectedIndex = index;
        skioSelectOptions.options[index].selected = true;
      }
    }
  }
  
  // Wait for SKIO plan picker to be available
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Wait a bit for SKIO shadow DOM to initialize
      setTimeout(initSkioSwatchSync, 500);
    });
  } else {
    setTimeout(initSkioSwatchSync, 500);
  }
})();

